import { History } from "history";
import { useCallback } from "react";

import { asyncComponent } from "components/AsyncComponent";
import { Store } from "redux";
import { injectReducer } from "redux/reducers";
import { injectSaga } from "redux/sagas";
import { State } from "redux/state";

export function Admin(history: History, store: Store<State>) {

    const load = useCallback(() => {
        return new Promise(resolve => {
            require.ensure(
                [],
                require => {
                    const componentModule = require("./containers/AdminRouteContainer") as any;
                    const component = componentModule.default;

                    // Admin Modules
                    const reducerModule = require("./modules") as any;
                    const reducer = reducerModule.default;
                    injectReducer(history, store as AsyncStore<State>, { key: "admin", reducer });

                    const sagaModule = require("./modules/sagas") as any;
                    const saga = sagaModule.default;
                    injectSaga(store as AsyncStore<State>, saga);

                    // App Modules
                    const appReducerModule = require("../App/modules") as any;
                    const appReducer = appReducerModule.appReducer;
                    injectReducer(history, store as AsyncStore<State>, { key: "app", reducer: appReducer });

                    const appSagaModule = require("../App/modules/sagas") as any;
                    const appSaga = appSagaModule.default;
                    injectSaga(store as AsyncStore<State>, appSaga);

                    resolve(component);
                },
                error => {
                    console.error(`Error loading admin route`);
                    console.error(error);
                },
                "admin"
            );
        });
    }, [history, store]);
    return asyncComponent(load as any);
}
